import { Navigate, useParams } from 'react-router-dom';
import CheckoutScreen from './CheckoutScreen.jsx';
import { ShiftGate } from '../../shared/ShiftGate.jsx';

// Wrapper guards against the sidebar NavLink rendering the literal `:sessionId?`
// token (since `featureRoutes` exposes a single `path` used both for matching
// and for sidebar `to=`). Anything other than a real id is normalised away.
function CheckoutEntry() {
  const { sessionId } = useParams();
  if (sessionId && (sessionId.startsWith(':') || sessionId === '*')) {
    return <Navigate to="/checkout" replace />;
  }
  return (
    <ShiftGate what="المحاسبة والخروج">
      <CheckoutScreen sessionId={sessionId || null} />
    </ShiftGate>
  );
}

export default {
  path: '/checkout/:sessionId?',
  element: <CheckoutEntry />,
  protected: true,
  permission: 'checkout.view',
  standalone: false,
  sidebar: { label: 'المحاسبة والخروج', icon: 'checkout', group: 'sales', order: 60 }
};
